window.toggleTrailer = function(button) {
    const trailerDiv = button.nextElementSibling;
    const iframe = trailerDiv.querySelector('iframe');
    const isOpen = trailerDiv.classList.contains('open');

    if (isOpen) {
        // Close the trailer
        trailerDiv.classList.remove('open');
        setTimeout(() => {
            trailerDiv.style.display = 'none';
            iframe.src = "";
        }, 400);
    } else {
        // Open the trailer
        let trailerUrl = button.getAttribute('data-trailer');
        let videoId = getYouTubeVideoId(trailerUrl);

        if (videoId) {
            trailerDiv.style.display = 'block';
            iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
            setTimeout(() => {
                trailerDiv.classList.add('open');
            }, 10);
        }
    }
}

// Helper function to extract the YouTube video ID from a URL or return it directly if it's just an ID
window.getYouTubeVideoId = function(url) {
    const regExp = /^.*(?:youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)?([^#&?]{11}).*/;
    const match = url.match(regExp);
    return match ? match[1] : null;
}
